import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CountryCode } from 'libphonenumber-js';

import KDSTextField from '@decisiv/ui-components/lib/components/TextField';
import { formatPhoneNumber } from 'utils/phoneFormatter';
import { TextFieldProps } from '../TextField';

interface PhoneTextFieldProps extends TextFieldProps {
  countryCode?: CountryCode;
}

const PhoneTextField = ({
  name,
  defaultValue,
  warningMessage,
  suppressWarningMessage,
  countryCode = 'US',
  ...props
}: PhoneTextFieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const fieldError = errors[name];

  const warningMessageToApply = useMemo(() => {
    if (suppressWarningMessage || !fieldError) return undefined;

    return warningMessage || fieldError.message?.toString();
  }, [fieldError, suppressWarningMessage, warningMessage]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => {
        const formattedValue = formatPhoneNumber(value, countryCode);

        return (
          <KDSTextField
            value={formattedValue}
            warningMessage={warningMessageToApply}
            onChange={({ target }) => onChange(target.value)}
            {...props}
          />
        );
      }}
    />
  );
};

export default PhoneTextField;
